import { AttachmentFile } from '@billy/design-system'
import { trackError } from '@billy/track-error'

import { VoucherFile } from '@modules-deprecated/inbox/types'

import { BohrScanResult } from '../../../../../types/bohrScanResult'

/**
 * @deprecated Use getParsedDataFromAttachment instead
 */
export const getBohrScanResultFromAttachmentFile = (
  attachmentFile: AttachmentFile | VoucherFile | undefined,
): BohrScanResult | undefined => {
  if (!attachmentFile?.dataJson) {
    return undefined
  }

  try {
    const parsedBohrResult = JSON.parse(attachmentFile.dataJson) as BohrScanResult

    if (parsedBohrResult._success !== undefined && !parsedBohrResult._success) {
      return undefined
    }

    return parsedBohrResult
  } catch (error) {
    trackError(error)
    return undefined
  }
}
